import React from 'react';

function PageHeadline({ children }) {
  return <h1>{children}</h1>;
}

export default PageHeadline;